// removed by extract-text-webpack-plugin
module.exports = {"projects_overview":"Projects__projects_overview__1LDSI"};


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/Projects.scss
// module id = 138
// module chunks = 0